import { render, staticRenderFns } from "./widget-time.vue?vue&type=template&id=a4725700&scoped=true"
import script from "./widget-time.vue?vue&type=script&lang=js"
export * from "./widget-time.vue?vue&type=script&lang=js"
import style0 from "./widget-time.vue?vue&type=style&index=0&id=a4725700&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4725700",
  null
  
)

export default component.exports